import type { ReactNode } from "react";
import { Link } from "../router";
import { useAppState } from "../state/appState";
import { useSession } from "../state/session";
import { currentSurface } from "../surface";
import { LinkState } from "./components";

/**
 * Работает ли рабочее место не со своей точкой.
 *
 * Касса и кухня обязаны разговаривать с мини-ПК в фудтруке: он работает и без
 * интернета. Если они попали в облако, значит мини-ПК недоступен и смена
 * работает в аварийном режиме — об этом нельзя молчать, потому что пропадёт
 * он тихо, а заметят это по остановившейся кухне.
 *
 * Владельца в админке это не касается: облако — её обычное место.
 */
function useOffsitePoint(): boolean {
  const { snapshot } = useAppState();
  const surface = currentSurface();

  if (snapshot?.settings.appRole !== "cloud") return false;
  return surface === "counter" || surface === "kitchen";
}

export function TopBar({ title, subtitle, extra }: { title: string; subtitle: string; extra?: ReactNode }) {
  const { staff, signOut } = useSession();
  const { connected } = useAppState();
  const offsite = useOffsitePoint();

  return (
    <header className="topbar">
      <Link className="brand" to="/">
        <span className="brand-mark">ПФ</span>
        <span>
          {title}
          <small>{subtitle}</small>
        </span>
      </Link>

      <div className="topbar-actions">
        {offsite ? (
          <span className="chip chip-alarm" title="Мини-ПК в фудтруке недоступен, рабочее место подключено к облаку">
            Мини-ПК недоступен · работаем через интернет
          </span>
        ) : null}
        {extra}
        <LinkState connected={connected} />
        {staff ? (
          <span className="who">
            <strong>{staff.name}</strong>
            <small>{staff.roleTitle}</small>
          </span>
        ) : null}
        <button type="button" className="btn btn-sm" onClick={() => void signOut()}>
          Выйти
        </button>
      </div>
    </header>
  );
}
